import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Modal} from 'shells/modal/modal';
import {OnboardingPage} from 'shells/onboarding-page/onboarding-page';

import {HelpBodyClosedLeadTasks} from './help-body-closed-lead-tasks';
import {HelpGraphicClosedLeadTasks} from './help-graphic-closed-lead-tasks';

type Props = {
    onClose: () => void;
    isOpen: boolean;
};

export class HelpClosedLeadTasks extends React.PureComponent<Props> {
    render() {
        return (
            <div>
                <Modal
                    isOpen={this.props.isOpen}
                    onClose={this.props.onClose}
                    noPadding={true}
                    closeButton={false}
                    preventBodyScroll={false}
                    maxHeight={500}
                >
                    <OnboardingPage
                        type='singlePage'
                        bodyComponent={<HelpBodyClosedLeadTasks />}
                        artBackgroundColor={colors.plumDk}
                        artImage={<HelpGraphicClosedLeadTasks />}
                        buttonText='Done'
                        onClose={this.props.onClose}
                    />
                </Modal>
            </div>
        );
    }
}
